export const FETCH_BOARDS_PENDING="FETCH_BOARDS_PENDING";
export const FETCH_BOARDS_SUCCESS="FETCH_BOARDS_SUCCESS";
export const FETCH_BOARDS_ERROR="FETCH_BOARDS_ERROR";

export const FETCH_BOARD_ISSUES_PENDING="FETCH_BOARD_ISSUES_PENDING";
export const FETCH_BOARD_ISSUES_SUCCESS="FETCH_BOARD_ISSUES_SUCCESS";
export const FETCH_BOARD_ISSUES_ERROR="FETCH_BOARD_ISSUES_ERROR";